module.exports = __webpack_public_path__ + "media/music/punchy_bass_8-b3cb364a.mp3";